const getcount = (customerId) => {
  let updateWishlistCountUrl = cartBaseUrl+v3WishlistCountEndPont+customerId+"/count";
  console.log(updateWishlistCountUrl,"getcount");
  $.ajax({
    async:true,
    type: 'GET',
    timeout: ajaxCallTimeout,
    dataType: 'json',
    contentType: 'application/json',
    headers: getV3Header(),
    error: function (data) {
      $.unblockUI();
      if(data !== undefined){
        if(!($.isEmptyObject(data))){
          var isResponseTextExists = data.hasOwnProperty(data.responseText);
          if(isResponseTextExists === true && data.responseText !== null){
            var responseErrorObj = JSON.parse(data.responseText);
            if(!($.isEmptyObject(responseErrorObj))){
              var isErrorObjectExists = responseErrorObj.hsaOwnProperty("error");
              if(isErrorObjectExists === true && responseErrorObj.error !== null){
                var errorObj = responseErrorObj.error;
                if(!($.isEmptyObject(errorObj))){
                  var isErroeMessageExists = errorObj.hasOwnProperty("message");
                  if(isErroeMessageExists === true && errorObj.message !== null){
                    var errorMessage = errorObj.message;
                    Sentry.captureMessage('Error in getWishlistData function'+errorMessage);
                    Sentry.captureException(data);
                    swal({
                      title: '',
                      text: errorMessage,
                      type: 'error',
                      confirmButtonText: 'OK',
                      closeOnCancel: false,
                      allowOutsideClick: false
                    });
                  }
                }
              }
            }
          }
        }
      }
    },
    url: updateWishlistCountUrl,
    statusCode: {
      200: function (data) {
        
        $('#wishlistCount').text(data.count)
      },
      302: function (data) {
        var responseErrorObj = JSON.parse(data.responseText);
        var errorObj = responseErrorObj.error;
        var errorMessage = errorObj.message;
        Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
        Sentry.captureException(data);
        $.unblockUI();
        swal({
          title: '',
          text: errorMessage,
          type: 'error',
          confirmButtonText: 'OK',
          closeOnCancel: false,
          allowOutsideClick: false
        });
        $('.swal2-confirm').click(function () {
          location.reload(true);
        });
      },
      401:function (data) {
        
        var responseErrorObj = JSON.parse(data.responseText);
        var errorObj = responseErrorObj.error;
        var errorMessage = errorObj.message;
        Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
        Sentry.captureException(data);
        $.unblockUI();
      },
      403: function (data) {
        var responseErrorObj = JSON.parse(data.responseText);
        var errorObj = responseErrorObj.error;
        var errorMessage = errorObj.message;
        Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
        Sentry.captureException(data);
        $.unblockUI();
        swal({
          title: '',
          text: errorMessage,
          type: 'error',
          confirmButtonText: 'OK',
          allowOutsideClick: false
        });
      },
      400: function (data) {
        var responseErrorObj = JSON.parse(data.responseText);
        var errorObj = responseErrorObj.error;
        var errorMessage = errorObj.message;
        Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
        Sentry.captureException(data);
        $.unblockUI();
        swal({
          title: '',
          text: errorMessage,
          type: 'error',
          confirmButtonText: 'OK',
          allowOutsideClick: false
        });
      },
      500: function (data) {
        var responseErrorObj = JSON.parse(data.responseText);
        var errorObj = responseErrorObj.error;
        var errorMessage = errorObj.message;
        Sentry.captureMessage('Error in getCartDetails function'+errorMessage);
        Sentry.captureException(data);
        $.unblockUI();
        swal({
          title: '',
          text: errorMessage,
          type: 'error',
          confirmButtonText: 'OK',
          allowOutsideClick: false
        });
      }
    }
  }).fail(function(data, textStatus, xhr){
    console.log(data.getResponseHeader('x-request-id'));
  });
}